import { ChatOutlinedIcon, Flex, Text } from '@shared/components';

export default function EmptyComment() {
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(4),
        py: theme.spacing(6),
        border: `1px dashed ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.rounded(2),
        backgroundColor: theme.palette.grey[50],
      })}
    >
      <ChatOutlinedIcon sx={(theme) => ({ fontSize: 48, color: theme.palette.text.secondary })} />
      <Text variant='h4'>ยังไม่มีความคิดเห็น</Text>
    </Flex>
  );
}
